module.exports = __webpack_public_path__ + "static/media/tti_targeting@3x.fe3008aa.png";